export default "__VITE_ASSET__06758149__"